import { range } from 'lodash';
import { TStepItem } from '../../api/endpoints/SubsetOption';

const deriveSteps = (stepItem: TStepItem) => {
  const start = parseInt(stepItem.from, 10);
  const end = parseInt(stepItem.to, 10)
  const step = parseInt(stepItem.by, 10);

  return range(
    start,
    end + step,
    step
  );
};

export {
  deriveSteps
}
